import { Box, IconButton, useTheme } from '@mui/material'
import { useContext } from 'react'
import { ColorModeContext, tokens } from '../../theme'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import { NavLink } from 'react-router-dom'
import MenuList from '@mui/material/MenuList'
import Stack from '@mui/material/Stack'
import ClickAwayListener from '@mui/material/ClickAwayListener'

import React from 'react'

import * as Constants from '../../constants'

const Topbar = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  const colorMode = useContext(ColorModeContext)

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleClose = (event) => {
    setAnchorEl(null)
  }

  const logout = () => {
    fetch(Constants.HOST + '/logout', {
      token: JSON.parse(localStorage.getItem('user_data')).token,
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
    })
    localStorage.removeItem('user_data')
    window.location.assign('/');
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popper' : undefined

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      {/* SEARCH BAR */}
      <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      ></Box>

      {/* ICONS */}
      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === 'dark' ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        {/* get ref from component */}
        <IconButton onClick={handleClick}>
          <PersonOutlinedIcon />
        </IconButton>

        <Stack direction="row" spacing={2}>
          <div>
            <Popper
              id={id}
              open={open}
              anchorEl={anchorEl}
              role={undefined}
              placement="bottom-start"
              transition
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom-start' ? 'left top' : 'left bottom',
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        autoFocusItem={false}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                      >
                        <MenuItem as={NavLink} to="/profile">
                          Configurações
                        </MenuItem>
                        <MenuItem onClick={logout}>Sair</MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        </Stack>
      </Box>
    </Box>
  )
}

export default Topbar
